import React, { Component } from 'react';
import {connect} from "react-redux";
import {PropTypes} from "prop-types";

import {bindActionCreators} from "redux";
import * as Actions from "../../../../store/modules/journals";

import {getObjectLength} from "../../../../utils/functions"

class ResourceSide extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    render() {

        const record = this.props.record;
        // console.log(record)
        const fullText = this.props.fullText;
        // console.log(fullText);
        // console.log(this.props.facet);
        return (
            <div className="right-side-group">
                <div className="">
                    <h4 className="con-title d-flex align-items-center mb-3">
                        <span className="icon icon-size-16 icon-link-blue mr-2" />Extra Link
                    </h4>
                    <div>
                        <div className="dot-text-list">
                            {record.wos_id &&
                                <div className="list-cell"><a href={"https://www.webofscience.com/wos/woscc/full-record/WOS:"+record.wos_id} target="_blank">Web of Science</a></div>
                            }
                            {record.scopus_id &&
                            <div className="list-cell"><a href={"https://www.scopus.com/inward/record.uri?partnerID=40&eid="+record.scopus_id} target="_blank">Scopus</a></div>
                            }
                            {record.kci_id &&
                            <div className="list-cell"><a href={"https://www.kci.go.kr/kciportal/ci/sereArticleSearch/ciSereArtiView.kci?sereArticleSearchBean.artiId="+record.kci_id} target="_blank">KCI(Korea Citation Index)</a></div>
                            }
                            {record.doi &&
                            <div className="list-cell"><a href={"https://doi.org/"+record.doi} target="_blank">DOI article link</a></div>
                            }
                        </div>
                    </div>
                </div>
                {/*<div className="mt-px-20 pt-px-20 border-top border-lightgray">*/}
                {/*    <h4 className="con-title d-flex align-items-center mb-3">*/}
                {/*        <span className="icon icon-size-16 icon-document-blue mr-2" />논문후기(준비중)*/}
                {/*        <span className="icon icon-size-24 icon-warning-black ml-auto" />*/}
                {/*    </h4>*/}
                {/*    <div>*/}
                {/*        <a href="#" className="btn-review-item mb-px-20">*/}
                {/*            <div className="d-flex justify-content-between">*/}
                {/*                <div className="color-lightpurple"><strong>홍길동</strong></div>*/}
                {/*                <div className="color-softblack">2020.05.20</div>*/}
                {/*            </div>*/}
                {/*            <div className="color-black mt-1">타이틀 입니다.</div>*/}
                {/*            <div className="color-lightblack mt-1">설명글 입니다.</div>*/}
                {/*        </a>*/}
                {/*        <a href="#" className="btn-review-item">*/}
                {/*            <div className="d-flex justify-content-between">*/}
                {/*                <div className="color-lightpurple"><strong>홍길동</strong></div>*/}
                {/*                <div className="color-softblack">2020.05.20</div>*/}
                {/*            </div>*/}
                {/*            <div className="color-black mt-1">타이틀 입니다.</div>*/}
                {/*            <div className="color-lightblack mt-1">설명글 입니다.</div>*/}
                {/*        </a>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="mt-px-20 pt-px-20 pb-px-20 border-top border-bottom border-lightgray">*/}
                {/*    <h4 className="con-title">*/}
                {/*        <a href="#" className="d-flex align-items-center color-black">*/}
                {/*            <span className="icon icon-size-16 icon-pet-blue mr-2" />저자에게 질문하기(준비중)*/}
                {/*            <span className="icon icon-size-16 icon-more-arrow-blue ml-auto" />*/}
                {/*        </a>*/}
                {/*    </h4>*/}
                {/*</div>*/}
            </div>
        )
    }
}

export default connect(
    (state) => ({
        fullText : state.journals.fullText ? state.journals.fullText : [],
        record: state.resources.record ? state.resources.record : [],
    }),
    (dispatch) => ({
        // dataActions: bindActionCreators(Actions, dispatch)
    }),
)(ResourceSide)

ResourceSide.propTypes = {
    fullText : PropTypes.array,
};
